import { render, staticRenderFns } from "./TareaManualTableComponent.vue?vue&type=template&id=4557ac6a&"
import script from "./TareaManualTableComponent.vue?vue&type=script&lang=js&"
export * from "./TareaManualTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports